/* @flow */

import de from './de'

const locales = {
  de: de
}

export default locales
